import { useEffect, useState } from 'react';
import { Input } from 'antd';
import Modal from '../../../components/Modal';
import { addHyphenPhoneNum } from '../../../lib/utils';
import toastMsg from '../../../lib/toastMsg';
import { ALIMTALK_VALIDATION_MSG, isValidTestPhone } from '../../../hooks/alimtalk/alimtalkSendDto';
import { AlimtalkTemplate } from '../../../types/alimtalk/template';
import { KakaoPreview } from './KakaoPreview';
import * as Styled from './style';

export type TestSendModalProps = {
  open: boolean;
  template?: AlimtalkTemplate;
  /** 미리보기 변수 매핑 (운영자 선택값) */
  previewVariables?: Record<string, string>;
  onClose: () => void;
  onSend: (testPhone: string) => void;
};

export const TestSendModal = (props: TestSendModalProps) => {
  const { open, template, previewVariables, onClose, onSend } = props;
  const [phone, setPhone] = useState('');

  // 모달은 항상 마운트 상태라 닫힐 때 입력값을 비워 재오픈 시 이전 번호가 남지 않게 한다
  useEffect(() => {
    if (!open) {
      setPhone('');
    }
  }, [open]);

  const handleOk = (): void => {
    // 백엔드 testPhone 패턴 미러 — 서버 400 전에 모달 안에서 즉시 피드백 (규칙 정의는 alimtalkSendDto에 단일화)
    if (!isValidTestPhone(phone)) {
      toastMsg.error(ALIMTALK_VALIDATION_MSG.TEST_PHONE_INVALID);
      return;
    }
    onSend(phone.trim());
  };

  return (
    <Modal
      isOpen={open}
      title="테스트 발송"
      width={460}
      isFooter
      okText="테스트 발송"
      onOk={handleOk}
      onClose={onClose}
      destroyOnClose
    >
      <Styled.FieldRow>
        <Styled.FieldLabel>수신 전화번호</Styled.FieldLabel>
        <Input
          placeholder="010-0000-0000"
          value={phone}
          onChange={(e) => setPhone(addHyphenPhoneNum(e.target.value))}
        />
      </Styled.FieldRow>

      {template && (
        <Styled.FieldRow>
          <Styled.FieldLabel>알림톡 미리보기</Styled.FieldLabel>
          <KakaoPreview template={template} variableValues={previewVariables} />
        </Styled.FieldRow>
      )}
    </Modal>
  );
};
